import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import TrendingCol from "../../../Trending";

import FeedList from "../../components/FeedList/FeedList";

import SortFeed from "./components/SortFeed/SortFeed";
import CreateFeed from "./components/CreateFeed/CreateFeed";

const FeedPage = () => {
  const [searchParams] = useSearchParams();
  const postType = searchParams.get("type") || "ALL";

  return (
    <Box
      sx={{
        display: "flex",
        gap: "15px",
      }}
    >
      <Box
        component="main"
        sx={{
          width: "100%",
          overflow: "hidden",
          height: "fit-content",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <CreateFeed />
        <SortFeed />
        <FeedList key={postType} />
      </Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <TrendingCol />
      </Box>
    </Box>
  );
};

export default FeedPage;
